import React, { useEffect } from 'react';
import VSLHeader from '../components/vsl/VSLHeader';
import VSLHero from '../components/vsl/VSLHero';
import VSLStatsBar from '../components/vsl/VSLStatsBar';
import VSLActionHub from '../components/vsl/VSLActionHub';
import VSLStickyBar from '../components/vsl/VSLStickyBar';

const VSL = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#faf8f5] min-h-screen font-sans">
      <VSLHeader />
      <VSLHero />
      <VSLStatsBar />
      <VSLActionHub />
      <VSLStickyBar />
    </div>
  );
};

export default VSL;